module.exports = __webpack_public_path__ + "img/cbd4de6.svg";